import { SocialNetworkConnectionStatus } from '../../../enums/social-network/social-network-connection-status.enum';
import { SocialNetworkRoleType } from '../../../enums/social-network/social-network-role-type.enum';
import { ProfileEntity } from '../../profile/profile-entity';
import { ProfileRoleLevel } from '../../profile/profile-role-level';
import { ProfileSpecialty } from '../../profile/profile-specialty';

export class Connection {
  public token: string;
  public profileId: number;
  public instanceId: string;
  public profile: ProfileEntity;
  public status: SocialNetworkConnectionStatus;
  public role: SocialNetworkRoleType;
  public profileInstanceId: string;
  public participantId: number;
  public following: boolean;
  public blocked?: boolean;
  public createdAt: Date;
  public updatedAt: Date;
  public firstname: string;
  public numberOfFollowers?: number;
  public practiceCountry?: string;
  public roleLevel?: ProfileRoleLevel;
  public specialty?: ProfileSpecialty;
}
